module.exports = __webpack_public_path__ + "static/img/ag_10.429c804.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/ag_10.png
// module id = 872
// module chunks = 1